import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=04ade37b&scoped=true&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=04ade37b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ade37b",
  null
  
)

export default component.exports